module.exports = __webpack_public_path__ + "img/image 16.716d1c11.png";